import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    NavContainer,
    NavItem,
    NavLeft,
    NavLink,
    NavList,
    NavLogoImg,
    NavRight
} from "./styles";
import { Container } from "../../styles";
import useAdminStatus from '../hooks/useAdminStatus';

const Navigation = () => {
    const navigate = useNavigate();
    const { username, isAdmin, userType } = useAdminStatus();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            setIsLoggedIn(true);
        }
    }, [isLoggedIn]);

    console.log('Navigation:', { username, isAdmin, userType }); // Log the values from useAdminStatus

    return (
        <Container>
            <NavContainer>
                <NavLeft>
                    <NavLink>
                        <Link to="/">
                            <NavLogoImg src="/assets/logo.png" alt="logo" />
                        </Link>
                    </NavLink>
                    <NavList>
                        <NavItem>
                            <NavLink><Link to="/">Home</Link></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink><Link to="/semesters">Semester</Link></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink><Link to="/courses">Courses</Link></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink><Link to="/classes">Classes</Link></NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink><Link to="/lecturers">Lecturers</Link></NavLink>
                        </NavItem>
                        {isAdmin && (
                            <NavItem>
                                <NavLink><Link to="/students">Students</Link></NavLink>
                            </NavItem>
                        )}
                    </NavList>
                </NavLeft>
                <NavRight>
                    <NavList>
                        {isLoggedIn ? (
                            <>
                                {(userType === 'student' || userType === 'lecturer') && (
                                    <NavItem>
                                        <NavLink>
                                            <Link to={`/profile/${username}`}>Profile</Link>
                                        </NavLink>
                                    </NavItem>
                                )}
                                <NavItem>
                                    <NavLink><Link to="/logout">Logout</Link></NavLink>
                                </NavItem>
                            </>
                        ) : (
                            <NavItem>
                                <NavLink><Link to="/login">Login</Link></NavLink>
                            </NavItem>
                        )}
                    </NavList>
                </NavRight>
            </NavContainer>
        </Container>
    );
}

export default Navigation;
